import request from '@/utils/request'


// 查询商家列表
export function listMerchantMerchant(query) {
  return request({
    url: '/merchant/merchant/list',
    method: 'post',
    data: query
  })
}

export function listSelectMerchant(query) {
  return request({
    url: '/merchant/merchant/list/select',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

export function pageSelectMerchant(query) {
  return request({
    url: '/merchant/merchant/page/select',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家分页
export function pageMerchantMerchant(query) {
  return request({
    url: '/merchant/merchant/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家详细
export function getMerchantMerchant(data) {
  return request({
    url: '/merchant/merchant/detail',
    method: 'get',
    params: data
  })
}

// 新增商家
export function addMerchantMerchant(data) {
  return request({
    url: '/merchant/merchant/add',
    method: 'post',
    data: data
  })
}

// 修改商家
export function updateMerchantMerchant(data) {
  return request({
    url: '/merchant/merchant/edit',
    method: 'post',
    data: data
  })
}

// 删除商家
export function delMerchantMerchant(data) {
  return request({
    url: '/merchant/merchant/delete',
    method: 'post',
    data: data
  })
}

export function getId() {
  return request({
    url: '/merchant/merchant/id',
    method: 'get'
  })
}


// 修改费率
export function updateRate(data) {
  return request({
    url: '/merchant/merchant/account/rate',
    method: 'post',
    data: data
  })
}

export function merchantStatus(data) {
  return request({
    url: '/merchant/merchant/status',
    method: 'post',
    data: data
  })
}
